import * as React from 'react';
import {
  Create,
  TextInput,
  BooleanInput,
  required,
  SelectArrayInput,
  SelectInput,
  ReferenceArrayInput,
  ReferenceInput,
} from 'react-admin';
import { orgsFields } from '../orgs.model';
import { validatePhone } from '../../utils/validation';
import ProviderRoleOrderedList from '../../components/ProviderRoleOrderedList';
import { useCreateWithRefresh } from '../../hooks/useMutationWithRefresh';
import { US_STATES_RESOURCE_NAME } from '../../usStates/usStates.dataProvider';
import { ENROLLMENT_METHOD_OPTIONS } from '../../utils/constants';
import { INSURANCE_PLANS_RESOURCE_NAME as INSURANCE_PLANS_RESOURCE } from '../../insurancePlans/insurance.plans.dataProvider';
import { validatePayerId, validateHealthieInsuranceId } from './utils/formValidation';
import { SectionedForm } from '../../components/layouts';

const OrgCreate = () => {
  const mutationOptions = useCreateWithRefresh('organizations', {
    successMessage: 'Organization created successfully',
  });

  const sections = [
    {
      title: "Basic Information",
      fields: [
        <TextInput
          key="name"
          source={orgsFields.orgName}
          label="Name"
          validate={required()}
        />,
        <SelectInput
          key="enrollmentMethod"
          source={orgsFields.enrollmentMethod}
          choices={ENROLLMENT_METHOD_OPTIONS}
          label="Enrollment Method"
          validate={required()}
        />,
        <TextInput 
          key="payerId"
          source={orgsFields.payerId} 
          label="Payer ID" 
          validate={validatePayerId}
        />,
        <ReferenceInput
          key="healthieInsurance"
          source={orgsFields.healthieInsuranceId}
          reference={INSURANCE_PLANS_RESOURCE}
          label="Healthie Insurance"
        >
          <SelectInput
            optionText="name_and_id"
            validate={validateHealthieInsuranceId}
          />
        </ReferenceInput>,
        <TextInput
          key="nursePhone"
          source={orgsFields.orgNursePhone}
          label="Nurse Phone"
          validate={validatePhone()}
        />
      ]
    },
    {
      title: "Feature Settings",
      fields: [
        <BooleanInput
          key="isActive"
          source={orgsFields.isActive}
          label="Active"
          defaultValue={true}
        />,
        <BooleanInput
          key="contentLibrary"
          source={orgsFields.contentLibraryEnabled}
          label="Content Library Enabled"
        />,
        <BooleanInput
          key="medicaidQuestion"
          source={orgsFields.medicaidIdRegistrationQuestionEnabled}
          label="Medicaid ID Registration Question Enabled"
        />,
        <BooleanInput 
          key="chatEnabled"
          source={orgsFields.chatEnabled} 
          label="Chat Enabled" 
        />,
        <BooleanInput
          key="enrollmentCode"
          source={orgsFields.enrollmentCodeRequired}
          label="Enrollment Code Required"
        />,
        <BooleanInput
          key="wicRequired"
          source={orgsFields.requiresWicId}
          label="WIC ID Required"
        />
      ]
    },
    {
      title: "Configuration",
      fields: [
        <ReferenceArrayInput
          key="usStates"
          source={orgsFields.usStates}
          perPage={10000}
          sort={{ field: 'name', order: 'ASC' }}
          reference={US_STATES_RESOURCE_NAME}
          label="US States"
          allowEmpty
        >
          <SelectArrayInput optionText="name" />
        </ReferenceArrayInput>,
        <ProviderRoleOrderedList key="providerRoles" rolesFieldName={orgsFields.roleIds} />
      ]
    }
  ];

  return (
    <Create mutationOptions={mutationOptions}>
      <SectionedForm sections={sections} />
    </Create>
  );
};

export default OrgCreate;
